import React from 'react';
import { Row, Col, Alert, Button } from 'react-bootstrap';

import FieldGroup from './common/FieldGroup.jsx';
import DropDownInput from './common/DropDownInput.jsx';

export default class GearSpecsComponent extends React.Component {

	componentDidMount() {
		this.props.findAllGears();
		this.props.findAllModelNos();
	}

	editItem() {
		this.props.editItem(this.props.gearSpec, {
			activePage: this.props.activePage,
			itemPerPage: this.props.itemPerPage
		}, this.props.forInsert);
	}

	render() {
		return (
			<div>
				<Row>
					<Col xs={2} sm={2} md={2}>
						<Button onClick={(event) => {
							this.editItem();
						}} bsStyle="info">
							Submit
					    </Button>
					</Col>
					<Col xs={10} sm={10} md={10}>
						<Alert bsStyle={this.props.alertStyle}>
							{this.props.alertMessage}
						</Alert>
					</Col>
				</Row>
				<br />
				<Row>
					<Col xs={12} sm={12} md={12}>
						<FieldGroup
							id="specId"
							type="text"
							label="料號代號"
							value={this.props.gearSpec.get('specId')}
							disabled={!this.props.forInsert}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.gearSpecValidation.get('specId')}
						/>
						<FieldGroup
							id="specName"
							type="text"
							label="料號名稱"
							value={this.props.gearSpec.get('specName')}
							placeholder=""
							required="true"
							onChange={(id, value) => {
								this.props.setValue(id, value);
							}}
							validation={this.props.gearSpecValidation.get('specName')}
						/>
						<DropDownInput id="gearName"
							label="產品名稱"
							required="true"
							options={this.props.allGears.map((value, key) => ({ label: value.get('alias_name'), value: value.get('gear_name') })).toJS()}
							selected={[{ label: this.props.gearSpec.get('gearAliasName'), value: this.props.gearSpec.get('gearName') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
								this.props.setValue('gearAliasName', label);
							}}
							validation={this.props.gearSpecValidation.get('gearName')}
						/>
						<DropDownInput id="sModelNo"
							label="型號名稱"
							required="true"
							options={this.props.allModelNos.map((value, key) => ({ label: value.get('model_display_name'), value: value.get('model_no') })).toJS()}
							selected={[{ label: this.props.gearSpec.get('modelDisplayName'), value: this.props.gearSpec.get('modelNo') }]}
							onChange={(id, value, label) => {
								this.props.setValue(id, value);
								this.props.setValue('modelDisplayName', label);
							}}
							validation={this.props.gearSpecValidation.get('sModelNo')}
						/>
					</Col>
				</Row>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/GearSpecEditComponent.jsx